/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useEffect, useState} from "react";
// react plugin used to create charts
// import { Line, Bar } from "react-chartjs-2";
import Swal from "sweetalert2";
import axios from "axios";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { BASE_URL } from "utils/constants";
 import Line from "../components/Chart/Line"
function Dashboard() {

  const [services, setServices] = useState([]);
  const [Reinforcements, setReinforcements] = useState([]);
  
  
  useEffect(async() => {
        try {
            const res = await axios.get(`${BASE_URL}/services/getservices.php`);
            setServices(res.data.data);
        } catch {
            Swal.fire('Failed to get services!', '', 'error');
        }
  }, [])
  useEffect(async() => {
        try {
            const res = await axios.get(`${BASE_URL}/reinforcements/getreinforcements.php`);
     
            setReinforcements(res.data.data);
        } catch {
            Swal.fire('Failed to get reinforcements!', '', 'error');
        }
  }, [])
  return (
    <>
      <PanelHeader size="sm"/>
        
            <div className="content">
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardHeader>
                                <h4 className="title">Services</h4>
                                <hr />
                            </CardHeader>
                            <CardBody>
                               <h5> Reinforcement points : </h5>
                            <Line  color="blue" Reinforcements = {Reinforcements} />
                            </CardBody>
                            <CardBody className="all-icons">
                                <Row>
                                {services.map((s, key) => {
                                    return (
                                    <Col
                                        xl={3}
                                        lg={4}
                                        md={4}
                                        sm={6}
                                        xs={12}
                                        className="font-icon-list"
                                        key={key}
                                    >
                                        <a href={s.link} target="_blank">
                                        {s.type == 'edu' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{height: '250px', boxShadow: '5px 10px #FFA400'}}>
                                        <img className="col-12" src={s.image} alt='service image' style={{maxWidth: '60%', height: '90px'}}/>
                                        <p className="col-12 text-center fw-bolder" style={{fontSize: "14pt", color: "#0A1931", fontWeight: 'bold'}} >{s.name}</p>
                                        </div>}
                                        {s.type == 'microsoft' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{height: '250px', boxShadow: '5px 10px #39A2DB'}}>
                                        <img className="col-12" src={s.image} alt='service image' style={{maxWidth: '35%', height: '70px'}}/>
                                        <p className="col-12 text-center fw-bolder" style={{fontSize: "14pt", color: "#0A1931", fontWeight: 'bold'}} >{s.name}</p>
                                        </div>}
                                        {s.type == 'google' && <div className="row font-icon-detail align-items-even justify-content-center service" style={{height: '250px', boxShadow: '5px 10px #81B214'}}>
                                        <img className="col-12" src={s.image} alt='service image' style={{maxWidth: '35%', height: '70px'}}/>
                                        <p className="col-12 text-center fw-bolder" style={{fontSize: "14pt", color: "#0A1931", fontWeight: 'bold'}} >{s.name}</p>
                                        </div>}
                                        </a>
                                    </Col>
                                    );
                                })}
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
    </>
  );
}

export default Dashboard;
